const languageList = [
	{ name: 'English', code: 'en' },
	{ name: 'Hungarian (Magyar)', code: 'hu' }
];

export default languageList;
